const BSDetail = () => (
  <div className="container my-5">
    <h2>BS - Wilmington University</h2>
    <p>Details about Allied Health Education.</p>
  </div>
);

export default BSDetail;